import { TYPE_OF_USER, TYPE_OF_USER_FM, TYPE_OF_USER_MOVING } from "Constants";

export type MemoryStatus = {
  completed: boolean;
  cancelled: boolean;
  inProgress: boolean;
  planned: boolean;
};

export type DatesByMemberAvailability = {
  startDate: Date;
  endDate: Date;
};

export type FileData = {
  uri: string;
  filename: string;
  fileType: string;
};

export const getTypes = (isMoving: boolean, isFMVersion: boolean) => {
  if (isMoving) {
    return TYPE_OF_USER_MOVING;
  }
  if (isFMVersion) {
    return TYPE_OF_USER_FM;
  }

  return TYPE_OF_USER;
};
